import styled from 'styled-components';
import Carot from '../../../../global/icons/Carot';

export const IMAGE_GAP = 14;

export const Arrow = styled(Carot).attrs(p => ({
  strokeColor: p.theme.product.specs.circles.activeColor
}))`
  height: 14px;
  position: absolute;
  top: calc(50% - 7px);
  transform: scale(4) rotate(90deg);
`;

export const ArrowWrapper = styled.div`
  cursor: pointer;
  height: 100%;
  margin-left: 7px;
  margin-right: 7px;
  opacity: 0.3;
  position: absolute;
  right: ${p => !p.left && 0};
  transform: ${p => !p.left && 'rotate(180deg)'};
  width: 64px;
  z-index: 1;

  :hover {
    opacity: 1;
  }
`;

export const Circle = styled.div`
  background-color: ${p =>
    p.active
      ? p.theme.product.specs.circles.activeColor
      : p.theme.product.specs.circles.color};
  border-radius: 100%;
  display: inline-block;
  height: 19px;
  transition: background-color 240ms ease-in-out;
  width: 19px;

  &:not(:last-child) {
    margin: 0 19px 0 0;
  }
`;

export const CircleWrapper = styled.div`
  margin: 38px 0 38px 0;
  text-align: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

// IE11 has issues with images in flexbox layout, so now
// Image and ImageWrapper use a non-flexbox vertical centering
// solution I found on https://medium.com/@sevcsik/css-vertical-alignment-without-flexbox-a83eac44c574,
// they have a working prototype at http://jsfiddle.net/hx00epqu/18/
export const Image = styled.img`
  max-height: 100%;
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
`;

export const ImageWrapper = styled.div`
  align-items: center;
  background-color: ${p => p.theme.product.specs.imagesBackground};
  cursor: pointer;
  height: 360px;
  margin: 0 ${IMAGE_GAP / 2}px;
  min-width: calc((100% / 3) - ${IMAGE_GAP}px);
  padding: 20px 10px 54px;
  position: relative;
  text-align: center;
  transform: translateX(${p => `${p.translate}%`})
    translateX(${p => `${p.translate2}px`});
  transition: transform 240ms cubic-bezier(0.18, 0.47, 0.31, 1);

  &:before {
    content: "";
    height: 100%;
    width: 0px;
    display: inline-block;
    vertical-align: middle;
  }

  @media ${p => p.theme.media.tablet} {
    height: 260px;
  }
`;

export const Label = styled.h3`
  color: ${p => p.theme.color.headerPrimary};
  font-family: ${p => p.theme.font.sourceSans};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LabelWrapper = styled.div`
  background-color: #ebebeb;
  bottom: 0;
  height: 54px;
  left: 0;
  padding: 20px;
  position: absolute;
  text-align: left;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: ${p => p.center && 'center'};
  min-width: 100%;
  overflow: hidden;
`;
